export default __webpack_public_path__ + "static/media/fb-large.cf1dfc9f.svg";